import { useContext } from 'react';
import { EntityContext } from 'context/entityContext';

export default useUrlForTopic;

/**
 * The useUrlForTopic hook returns an absolute url based on the passed topic.
 * @param {string} topic topic as string e.g. 'territory' or string composed of topic and subtopic e.g. 'charts/official'
 */
function useUrlForTopic(topic: string | string[]): string {
  const { entityIds, entityType, parentEntityId, isVersion } = useContext(
    EntityContext
  );

  const topicString = Array.isArray(topic) ? topic.join('/') : topic;

  if (isVersion) {
    return `/entity/${entityType}/${parentEntityId}/version/${entityIds}/${topicString}`;
  }
  return `/entity/${entityType}/${entityIds}/${topicString}`;
}
